routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.blogDetail', {
      url: "blogDetail/{blogSlug}",
      template: `<blog-detail sh-ctrl="shCtrl"></blog-detail>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/blog/blog-detail/blog-detail.config.js